import {SimpleGrid, Stack, Title} from '@mantine/core'

import {DashboardStatCard} from './dashboard-stat-card'
import {EquipmentUtilizationCard} from './equipment-utilization-card'
import {useDashboardData} from './use-dashboard-data'
import {WorkersUtilizationCard} from './workers-utilization-card'

export function DashboardPage() {
    const {statCards, workers, equipment, fleetQuery} = useDashboardData()

    return (
        <Stack gap="lg">
            <Title order={1}>Dashboard</Title>

            <SimpleGrid cols={{base: 1, sm: 2}} spacing="md">
                {statCards.map((stat) => (
                    <DashboardStatCard key={stat.title} stat={stat} />
                ))}
            </SimpleGrid>

            <Stack gap="md">
                <EquipmentUtilizationCard
                    equipment={equipment}
                    isLoading={fleetQuery.isLoading}
                    isError={fleetQuery.isError}
                    error={fleetQuery.error}
                    onRetry={() => void fleetQuery.refetch()}
                />
                <WorkersUtilizationCard
                    workers={workers}
                    isLoading={fleetQuery.isLoading}
                    isError={fleetQuery.isError}
                    error={fleetQuery.error}
                    onRetry={() => void fleetQuery.refetch()}
                />
            </Stack>
        </Stack>
    )
}
